// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__3e3sF","hideOnTablet":"styles_hideOnTablet__2ETZE","hideOnMobile":"styles_hideOnMobile__RYuF5","cards":"styles_cards__ZelAX"};